<script lang="ts">
  import { onMount } from "svelte"; 
  import MainLayout from "../../layout/MainLayout.svelte"; 
  import { PermissionService } from "../../utils/misc/permission-utils";
  import { user } from "../../app.store";
 
  let cancreate : boolean = PermissionService.isAllowedTo($user, 'activities.cancreate');
  let candelete : boolean = PermissionService.isAllowedTo($user, 'activities.candelete');
  let canedit : boolean = PermissionService.isAllowedTo($user, 'activities.canedit');
  

import ActivityListPageInner from "./ActivityListPageInner.svelte";

let filter_mine = 0;
  

</script>

<MainLayout>
  <ActivityListPageInner entityId={null} entityTpe={null} />
</MainLayout>
